// framework/client/components/ScheduledTasks.js (assuming this is your SchedulerCrud)
import { ComponentBase } from "../core/ComponentBase.js";

export class ScheduledTasks extends ComponentBase { // Renamed class to ScheduledTasks to match original
    static eventGroup = 'scheduledTasks'; // Keep static eventGroup if needed for specific event handling

    constructor(config) {
        super(config);
        this.dataCrud = null;
        this.currentProjectId = null; // NEW
        this._boundHandleProjectSelected = this.handleProjectSelected.bind(this); // NEW
        // Use instanceId for eventGroup if provided, otherwise default
        this.eventGroup = this.config.instanceId ? `${this.config.instanceId}-crud` : ScheduledTasks.eventGroup;
    }

    async initialize() {
        this.appClient.events.local.on('projectSelected', this._boundHandleProjectSelected); // NEW
        await super.initialize();
    }

    async initializeDataCrud() { // NEW METHOD
        if (this.dataCrud && typeof this.dataCrud.destroy === 'function') {
            this.dataCrud.destroy();
            this.dataCrud = null;
        }

        const dataProviderContext = {};
        if (this.currentProjectId) {
            dataProviderContext.projectId = this.currentProjectId;
        }

        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            eventGroup: this.eventGroup, // Use dynamic eventGroup
            appClient: this.appClient,
            rpcClass: "SchedulerRpc",
            rpcMethod: "list",
            schemaPath: "collections/schedules",
            title: "Scheduled Tasks",
            layout: 'horizontal',
            layoutConfig: {
                formWidth: '600px'
            },
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'name', label: 'Name', render: (value) => `<div class="fw-bold">${value}</div>` },
                    { name: 'description', label: 'Description' },
                    {
                        name: 'schedule', label: 'Schedule', render: (value) => {
                            return value === 'once' ? 'One-time' : value;
                        }
                    },
                    { name: 'actionType', label: 'Action Type' },
                    {
                        name: 'enabled', label: 'Enabled', render: (value) => {
                            return value ? '<i class="bi bi-check-circle-fill text-success"></i>' : '<i class="bi bi-x-circle-fill text-danger"></i>';
                        }
                    },
                    {
                        name: 'nextRun', label: 'Next Run', render: (value) => {
                            return value ? new Date(value).toLocaleString() : '-';
                        }
                    },
                    {
                        name: 'lastRun', label: 'Last Run', render: (value) => {
                            return value ? new Date(value).toLocaleString() : '-';
                        }
                    },
                    {
                        name: 'dispatch', label: 'Dispatch', render: (value) => {
                            if (!value) return '<span class="text-muted">one</span>';
                            const mode = value.mode || 'one';
                            const extra = value.tag ? ` (${value.tag})` : value.instanceId ? ` (${value.instanceId.slice(0,8)})` : '';
                            return `<span class="badge bg-secondary">${mode}${extra}</span>`;
                        }
                    },
                    {
                        name: 'sourceService', label: 'Source', render: (value) => {
                            return value ? `<span class="text-muted" style="font-size:var(--ab-text-sm);">${value}</span>` : '-';
                        }
                    }
                ],
                filter: {
                    enabled: true,
                    fields: {
                        search: {
                            type: 'text',
                            label: 'Search',
                            placeholder: 'Search by name...'
                        },
                        actionType: {
                            type: 'select',
                            label: 'Action Type',
                            options: [
                                { value: '', label: 'All Types' },
                                { value: 'event', label: 'Event' },
                                { value: 'rpc', label: 'RPC' },
                                { value: 'workflow', label: 'Workflow' },
                                { value: 'aiMessage', label: 'AI Message' }
                            ]
                        },
                        category: {
                            type: 'select',
                            label: 'Category',
                            options: [
                                { value: '', label: 'All Categories' },
                                { value: 'user', label: 'User' },
                                { value: 'automation', label: 'Automation' },
                                { value: 'campaign', label: 'Campaign' },
                                { value: 'system', label: 'System' }
                            ]
                        },
                        'context.agentName': {
                            type: 'text',
                            label: 'Agent',
                            placeholder: 'Filter by agent name...'
                        },
                        sourceService: {
                            type: 'text',
                            label: 'Source App',
                            placeholder: 'e.g. AIAssistant'
                        },
                        enabled: {
                            type: 'select',
                            label: 'Status',
                            options: [
                                { value: '', label: 'All' },
                                { value: 'true', label: 'Enabled' },
                                { value: 'false', label: 'Disabled' }
                            ]
                        }
                    }
                },
            },

            formConfig: {
                mode: 'display',
                fields: {
                    name:        { type: 'text',    label: 'Name' },
                    description: { type: 'text',    label: 'Description', multiline: true, rows: 2 },
                    schedule:    { type: 'text',    label: 'Schedule', placeholder: '* * * * * or once:ISO8601' },
                    actionType: {
                        type: 'select',
                        label: 'Action Type',
                        options: [
                            { value: 'event',     label: 'Event' },
                            { value: 'rpc',       label: 'RPC' },
                            { value: 'workflow',  label: 'Workflow' },
                            { value: 'aiMessage', label: 'AI Message' }
                        ]
                    },

                    // ── event fields ──────────────────────────────────────────
                    'actionConfig.eventName': {
                        type: 'text', label: 'Event Name',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'event',
                    },
                    'actionConfig.eventData': {
                        type: 'text', label: 'Event Data (JSON)', multiline: true, rows: 2,
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'event',
                    },

                    // ── rpc fields ────────────────────────────────────────────
                    'actionConfig.targetService': {
                        type: 'text', label: 'Target Service',
                        placeholder: 'e.g. AIAssistant',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'rpc',
                    },
                    'actionConfig.rpcMethod': {
                        type: 'text', label: 'RPC Method',
                        placeholder: 'e.g. MyRpc.myMethod',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'rpc',
                    },
                    'actionConfig.params': {
                        type: 'text', label: 'Parameters (JSON)', multiline: true, rows: 2,
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'rpc',
                    },

                    // ── workflow fields ───────────────────────────────────────
                    'actionConfig.workflowTargetService': {
                        type: 'text', label: 'Target Service',
                        placeholder: 'e.g. AIAssistant',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'workflow',
                    },
                    'actionConfig.workflowName': {
                        type: 'text', label: 'Workflow Name',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'workflow',
                    },
                    'actionConfig.workflowArgs': {
                        type: 'text', label: 'Workflow Args (JSON)', multiline: true, rows: 2,
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'workflow',
                    },

                    // ── aiMessage fields ──────────────────────────────────────
                    'actionConfig.agentName': {
                        type: 'text', label: 'Agent Name',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'aiMessage',
                    },
                    'actionConfig.message': {
                        type: 'text', label: 'Message', multiline: true, rows: 3,
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'aiMessage',
                    },
                    'actionConfig.useCurrentContext': {
                        type: 'boolean', label: 'Resume current conversation',
                        dependsOn: ['actionType'],
                        visibleWhen: (data) => data.actionType === 'aiMessage',
                    },

                    // ── dispatch ──────────────────────────────────────────────
                    'dispatch.mode': {
                        type: 'select', label: 'Dispatch Mode',
                        options: [
                            { value: 'one',      label: 'One — load balanced (default)' },
                            { value: 'all',      label: 'All — every instance' },
                            { value: 'tag',      label: 'Tag — instances with specific tag' },
                            { value: 'instance', label: 'Instance — specific process' },
                        ],
                    },
                    'dispatch.tag': {
                        type: 'text', label: 'Tag',
                        dependsOn: ['dispatch.mode'],
                        visibleWhen: (data) => data.dispatch?.mode === 'tag',
                    },
                    'dispatch.instanceId': {
                        type: 'text', label: 'Instance ID',
                        dependsOn: ['dispatch.mode'],
                        visibleWhen: (data) => data.dispatch?.mode === 'instance',
                    },

                    // ── general ───────────────────────────────────────────────
                    category: {
                        type: 'select', label: 'Category',
                        options: [
                            { value: 'user',       label: 'User' },
                            { value: 'automation', label: 'Automation' },
                            { value: 'campaign',   label: 'Campaign' },
                            { value: 'system',     label: 'System' }
                        ],
                        readonly: true
                    },
                    enabled:  { type: 'boolean', label: 'Enabled' },
                    timeZone: { type: 'text',    label: 'Timezone', placeholder: 'e.g. America/New_York' },
                },
                sections: [
                    {
                        title: 'General',
                        fields: ['name', 'description', 'schedule', 'actionType', 'category', 'enabled', 'timeZone'],
                    },
                    {
                        title: 'Action Configuration',
                        fields: [
                            // event
                            'actionConfig.eventName', 'actionConfig.eventData',
                            // rpc
                            'actionConfig.targetService', 'actionConfig.rpcMethod', 'actionConfig.params',
                            // workflow
                            'actionConfig.workflowTargetService', 'actionConfig.workflowName', 'actionConfig.workflowArgs',
                            // aiMessage
                            'actionConfig.agentName', 'actionConfig.message', 'actionConfig.useCurrentContext',
                        ],
                    },
                    {
                        title: 'Dispatch',
                        fields: ['dispatch.mode', 'dispatch.tag', 'dispatch.instanceId'],
                    },
                ],
                actions: {
                    save: true,
                    cancel: true
                }
            },

            dataConfig: {
                autoLoad: false,
                pageSize: 25,
                context: dataProviderContext,
            }
        });
    }

    async handleProjectSelected({ projectData }) { // NEW METHOD
        const newProjectId = projectData ? projectData._id : null;
        if (this.currentProjectId === newProjectId) {
            return;
        }
        this.currentProjectId = newProjectId;
        this.log.info(`Project selected in ScheduledTasks: ${this.currentProjectId}`);

        if (this.dataCrud) {
            const newContext = this.currentProjectId ? { projectId: this.currentProjectId } : {};
            this.dataCrud.setContext(newContext);
            if (this.currentProjectId) {
                await this.dataCrud.refreshData();
            } else {
                this.dataCrud.setData([], 0); // Clear data
            }
        } else {
            await this.initializeDataCrud();
        }
        if (this.container) this.render();
    }

    async initAfterLogin() {
        if (this.contextId) {
            this.currentProjectId = this.contextId;
        } else {
            this.currentProjectId = this.appClient.getSharedData('selectedProjectId') || null;
        }
        await this.initializeDataCrud();
        // Re-render now that dataCrud is ready (render() ran before initAfterLogin,
        // so the container was showing the loading placeholder).
        if (this.container) await this.render();
        // Load data after render so DataCrud's DOM is in place.
        await this.dataCrud.refreshData();
    }

    async render() { // Modified render
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'scheduled-tasks-container';
        }
        this.container.innerHTML = '';

        if (this.dataCrud) {
            this.container.appendChild(await this.dataCrud.render());
        } else {
            const loadingPlaceholder = document.createElement('div');
            loadingPlaceholder.textContent = 'Loading scheduled tasks manager...';
            this.container.appendChild(loadingPlaceholder);
        }
        return this.container;
    }

    destroy() {
        this.appClient.events.local.off('projectSelected', this._boundHandleProjectSelected); // NEW
        this.dataCrud?.destroy();
        this.dataCrud = null;
        super.destroy();
    }
}